/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('product:added', function(event) {
console.log("respuesta-----");
  fetch('/cart.js')
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error('Network response was not ok.');
  })
  .then(data => {
    let count = document.querySelector(`.Header__Icon .Header__CartDot`);
    count.innerHTML = data.item_count;
    console.log(data.item_count);
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
});
/*fields custom*/

function printText(inputItem){
  let labelInput = inputItem.dataset.label;
  console.log(labelInput);
  document.querySelector(`#${labelInput}`).textContent = `${inputItem.value.length}/${inputItem.maxLength}`;
  document.querySelector(`.js-field--item .${labelInput}`).textContent = inputItem.value;
  /*document.querySelector(`.js-field--item .${labelInput}__mobile`).textContent = inputItem.value;*/
}

function changeFamily(labelItem){
  let arrayTexts = document.querySelectorAll(`.ProductImage__field`);
  arrayTexts.forEach((item) => {
    item.dataset.family = `${labelItem.value}`;
  });
}

/*text image*/
const contentInputs = document.querySelector('.js-custom-inputs');
if(Boolean(contentInputs)){
  contentInputs.addEventListener('keyup', (e)=>{
    if(e.target.classList.contains('field__input')){
      printText(e.target);
    }
  }); 
}
/*family radio*/
const contentRadios = document.querySelector('.js-custom-radios');
if(Boolean(contentRadios)){
  contentRadios.addEventListener('change', (e)=>{
    if(e.target.tagName == 'INPUT'){
      changeFamily(e.target);
    }
  }); 
}

/*sticky botton addtocart*/

function toAddtoCart(btn) {
  const btnAddtoCart = document.querySelector(`${btn.dataset.btnProduct}`);
  btnAddtoCart.click();
  console.log(btnAddtoCart);
}

function addItems(variantId, quantity, btn){
  btn.classList.add('unavailable');
  addItem(variantId, quantity, btn);  
}

async function addItem(variantId, quantity, btn) {
 const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
    .then(response => response.json())
      
    .then(data => { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      return data;   
    })
    .catch((error) => {
      return error;
    });
}
async function removeItem(variantID) {
    const result = await fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            line: variantID,
            quantity: 0
        })
    })
    .then(response => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
      }));
      return response.json();
    })
    .catch((error) => {
      return error;
    });
}

class CartWatcher {
            
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const changes = await this.fetchCart();

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

function removeItems(variantId){
  removeItem(variantId);  
}

const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", (e) => {
  let searchPositionLine = e.detail.items.findIndex((item, index) => item.price == 0);
  if(e.detail.total_price < 10000 && searchPositionLine != -1){
    let searchPositionLineCurrent = searchPositionLine+1;
    removeItems(searchPositionLineCurrent);
  }
});

// logica nova pagina compte

document.addEventListener('DOMContentLoaded', function() {
  var link_misdatos = document.getElementById('misdatos');
  var link_misdirecciones = document.getElementById('misdirecciones');
  var link_mispedidos = document.getElementById('mispedidos');

  var pedidosDiv = document.getElementById('cargar-pedidos');
  var direccionesDiv = document.getElementById('cargar-direcciones');
  var datosDiv = document.getElementById('cargar-datos');

  if (link_misdatos) {
      link_misdatos.addEventListener('click', function(event) {
          event.preventDefault(); // Prevent the default action
          if (pedidosDiv) {
            pedidosDiv.style.display = 'none';
          }
        
          if (direccionesDiv) {
              direccionesDiv.style.display = 'none';
          }

          if (datosDiv) {
            datosDiv.style.display = 'block';
          }

          // Remove 'selected' class from the currently selected <li>
          var selectedLi = document.querySelector('.lista-selectores .selected');
          if (selectedLi) {
            selectedLi.classList.remove('selected');
          }

          link_misdatos.closest('li').classList.add('selected');
          
      });
  }

  if (link_misdirecciones) {
    link_misdirecciones.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default action
                 
         if (pedidosDiv) {
             pedidosDiv.style.display = 'none';
         }
         
         if (direccionesDiv) {
             direccionesDiv.style.display = 'block';
         }

         if (datosDiv) {
          datosDiv.style.display = 'none';
        }

      // Remove 'selected' class from the currently selected <li>
      var selectedLi = document.querySelector('.lista-selectores .selected');
      if (selectedLi) {
        selectedLi.classList.remove('selected');
      }

      link_misdirecciones.closest('li').classList.add('selected');

    }); 
  }

  if (link_mispedidos) {
    link_mispedidos.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default action
        if (pedidosDiv) {
          pedidosDiv.style.display = 'block';
      }
      
      if (direccionesDiv) {
          direccionesDiv.style.display = 'none';
      }

      if (datosDiv) {
        datosDiv.style.display = 'none';
      }
      // Remove 'selected' class from the currently selected <li>
      var selectedLi = document.querySelector('.lista-selectores .selected');
      if (selectedLi) {
        selectedLi.classList.remove('selected');
      }
  
      link_mispedidos.closest('li').classList.add('selected');
    });

  }
});